import {Route} from "../../registry/routes.js"
import AssetsFavouritesAdmin from "../../components/Favorites/admin/AssetsFavouritesAdmin.vue";

const r = new Route("assetFavouriteAdmin", "favourites-admin", {"assetFavouriteAdmin":AssetsFavouritesAdmin}, {componentType:"modal_component", title: "Upload"}, [], true, null)

export default r